export const myRequests = {
  en: {
    title: "My Requests",
    subtitle: "Start a new request or continue an existing one",
    welcome: {
      title: "Welcome to SOLARIIS",
      description: "Your password has been set successfully. Select a service to start your request.",
      getStarted: "Get Started",
    },
    pendingLimit: "You have {count} pending requests. Please wait for one to be approved before creating a new one.",
    createNew: "Create New Request",
    yourRequests: "Your Requests",
    noRequests: "No requests yet",
    noRequestsDesc: "Create your first service request to start working with us.",
    createRequest: "Create Request",
    companyPending: "Company details pending",
    draftDeleted: "Draft deleted",
    deleteFailed: "Failed to delete",
    unexpectedError: "An unexpected error occurred",
    // New Request
    newTitle: "New Request",
    newSubtitle: "Select the type of service to get started",
    loadServiceTypesError: "Failed to load service types.",
    createRequestError: "Failed to create request",
    // Edit Request
    editTitle: "Edit Request",
    onlyDrafts: "Only draft requests can be edited",
    loadFailed: "Failed to load request",
    backToRequests: "Back to My Requests",
    notFound: "Request not found",
    // Request Detail
    detail: {
      notFound: "Request not found",
      noPermission: "You don't have permission to view this request",
      loadFailed: "Failed to load request details",
      projectDetails: "Project Details",
      information: "Information",
      backToRequests: "Back to My Requests",
      serviceRequest: "Service Request",
      projectSummary: "Project Summary",
      teamNotes: "Team Notes:",
      company: "Company",
      completion: "Completion",
      created: "Created",
      lastUpdated: "Last Updated",
      selectedPackages: "Selected Packages",
      packages: "package(s)",
      yourResponses: "Your Responses",
      answers: "answers from your questionnaire",
      question: "Question",
      editMode: "Edit fields and save changes",
      viewMode: "Information gathered from your request",
      sections: "sections",
      saved: "Saved",
      select: "Select...",
      questionnaireProgress: "Questionnaire progress",
      fields: "fields",
      requiredPending: "{count} required field(s) pending",
      pending: "Pending",
      noAnswer: "No answer yet",
      additionalInfo: "Additional Information",
    },
    // Service types
    serviceTypes: {
      brand: "Brand Identity",
      product: "Product Design",
      discovery: "Discovery & Strategy",
      digitalDesign: "Digital Design",
      digitalMarketing: "Digital Marketing",
      subscription: "Agency Subscription",
    },
  },
  es: {
    title: "Mis Solicitudes",
    subtitle: "Inicia una nueva solicitud o continúa una existente",
    welcome: {
      title: "Bienvenido a SOLARIIS",
      description: "Tu contraseña se ha configurado correctamente. Selecciona un servicio para comenzar tu solicitud.",
      getStarted: "Comenzar",
    },
    pendingLimit: "Tienes {count} solicitudes pendientes. Por favor espera a que una sea aprobada antes de crear una nueva.",
    createNew: "Crear Nueva Solicitud",
    yourRequests: "Tus Solicitudes",
    noRequests: "No tienes solicitudes",
    noRequestsDesc: "Crea tu primera solicitud de servicio para comenzar a trabajar con nosotros.",
    createRequest: "Crear Solicitud",
    companyPending: "Detalles de empresa pendientes",
    draftDeleted: "Borrador eliminado",
    deleteFailed: "No se pudo eliminar",
    unexpectedError: "Ocurrió un error inesperado",
    newTitle: "Nueva Solicitud",
    newSubtitle: "Selecciona el tipo de servicio para comenzar",
    loadServiceTypesError: "Error al cargar los tipos de servicio.",
    createRequestError: "Error al crear la solicitud",
    editTitle: "Editar Solicitud",
    onlyDrafts: "Solo se pueden editar solicitudes en borrador",
    loadFailed: "Error al cargar la solicitud",
    backToRequests: "Volver a Mis Solicitudes",
    notFound: "Solicitud no encontrada",
    detail: {
      notFound: "Solicitud no encontrada",
      noPermission: "No tienes permiso para ver esta solicitud",
      loadFailed: "Error al cargar los detalles",
      projectDetails: "Detalles del Proyecto",
      information: "Información",
      backToRequests: "Volver a Mis Solicitudes",
      serviceRequest: "Solicitud de Servicio",
      projectSummary: "Resumen del Proyecto",
      teamNotes: "Notas del equipo:",
      company: "Empresa",
      completion: "Progreso",
      created: "Creada",
      lastUpdated: "Actualizada",
      selectedPackages: "Paquetes Seleccionados",
      packages: "paquete(s)",
      yourResponses: "Tus Respuestas",
      answers: "respuestas del cuestionario",
      question: "Pregunta",
      editMode: "Edita los campos y guarda los cambios",
      viewMode: "Información recopilada de tu solicitud",
      sections: "secciones",
      saved: "Guardado",
      select: "Seleccionar...",
      questionnaireProgress: "Progreso del cuestionario",
      fields: "campos",
      requiredPending: "{count} campo(s) requerido(s) pendiente(s)",
      pending: "Pendiente",
      noAnswer: "Sin respuesta",
      additionalInfo: "Información Adicional",
    },
    serviceTypes: {
      brand: "Identidad de Marca",
      product: "Diseño de Producto",
      discovery: "Descubrimiento y Estrategia",
      digitalDesign: "Diseño Digital",
      digitalMarketing: "Marketing Digital",
      subscription: "Suscripción de Agencia",
    },
  },
};
